import { createSelector } from 'reselect';
import { selectAllQueryParams } from '../../selectors/routing';

export default createSelector(
  [selectAllQueryParams(['backTo'])],
  ([backTo]) => ({
    backTo,
  }),
);
